export { default } from './cookie-policy';
